module.exports = __webpack_public_path__ + "img/支付宝扫一扫.1d3c76ba.png";